import { Dispatch } from "redux";
import React from "react";
import {
    setIsLeftTagModalOpenIndex,
    setIsRightTagModalOpenIndex,
} from "../EmployeeDetailSlice";
import { InfoCardProps } from "@hatch-digital-nl/abs-storybook/legacy";
import { QualificationInterface } from "../../../common/interfaces/QualificationInterface";
import {
    setIsCreateCertificateModalOpen,
    setSelectedEmployee,
    setSelectedQualification,
} from "../../../modals/CreateCertificateModal/CreateCertificateModalSlice";
import { EmployeeInterface } from "../../../common/interfaces/EmployeeInterface";

interface ModalData {
    ref: React.RefObject<HTMLDivElement | null>;
    openIndex: number;
    setOpenModalIndex: (index: number) => void;
}

export const mapQualificationsToInfoCards = (
    qualificationData: QualificationInterface[],
    employee: EmployeeInterface,
    modal: ModalData,
    dispatch: Dispatch,
    isLeftTagModalOpen: number,
    isRightTagModalOpen: number,
): InfoCardProps[] => {
    return qualificationData.map((qualification, index) => {
        return {
            onClickAddButton: () => {
                dispatch(setSelectedQualification(qualification));
                dispatch(setSelectedEmployee(employee));
                dispatch(setIsCreateCertificateModalOpen(true));
            },
            leftTagNames: qualification.function_group.map(
                (functionGroup) => functionGroup.name,
            ),
            rightTagNames: qualification.qualification_standards.map(
                (qualificationStandard) => qualificationStandard.name,
            ),
            isLeftTagOpen: index === isLeftTagModalOpen,
            isRightTagOpen: index === isRightTagModalOpen,
            onClickLeftTag: () => dispatch(setIsLeftTagModalOpenIndex(index)),
            onClickRightTag: () => dispatch(setIsRightTagModalOpenIndex(index)),
            leftTagRef: modal.ref,
            rightTagRef: modal.ref,
            title: qualification.name,
            description: qualification.qualification_standards,
            image: qualification.image_url,
            backgroundColor: index % 2 === 0 ? "#FFFBF9" : "#FFF",
        };
    });
};
